class SocialAccounts {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/social-accounts`;
    this.apiClient = apiClient;

  }

  async getAccounts() {

    return this.apiClient.get(this.basePath, {}, {});

  }

  async authorizeAccounts(data) {

    return this.apiClient.post(`${this.basePath}/authorizations`, {}, {}, data);

  }

  async addAuthorizedAccounts(authorizationId, data) {

    return this.apiClient.post(`${this.basePath}/authorizations/:authorizationId/accounts`, { authorizationId }, {}, data);

  }

  async removeAccount(accountId) {

    return this.apiClient.delete(`${this.basePath}/:accountId`, { accountId }, {});

  }

  async getTikTokCreatorDetails(accountId) {

    return this.apiClient.get(`${this.basePath}/:accountId/tiktok-creator-details`, { accountId }, {});

  }

  async getRedditCommunities(accountId) {

    return this.apiClient.get(`${this.basePath}/:accountId/reddit-communities`, { accountId }, {});

  }

  async addRedditCommunities(accountId, data) {

    return this.apiClient.post(`${this.basePath}/:accountId/reddit-communities`, { accountId }, {}, data);

  }

  async removeRedditCommunity(accountId, communityName) {

    return this.apiClient.delete(`${this.basePath}/:accountId/reddit-communities/:communityName`, { accountId, communityName }, {});

  }

  async checkRedditCommunity(accountId, data) {

    return this.apiClient.post(`${this.basePath}/:accountId/reddit-community-checks`, { accountId }, {}, data);

  }

}

export default SocialAccounts;
